import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface User {
  user_name: string;
  role: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private userSubject = new BehaviorSubject<User | null>(this.loadUserFromSession());
  user$ = this.userSubject.asObservable();

  constructor() {}

  // Charger les données de l'utilisateur depuis sessionStorage
  private loadUserFromSession(): User | null {
    const user_name = sessionStorage.getItem('user_name');
    const role = sessionStorage.getItem('user_roles')|| '';
    const user = user_name && role ? { user_name, role } : null;
    console.log('Utilisateur chargé depuis sessionStorage:', user); // Afficher l'utilisateur et son rôle
    return user;
  }

  // Mettre à jour les informations utilisateur dans sessionStorage et notifier les abonnés
  setUserInfo(user_name: string, role: string): void {
    sessionStorage.setItem('user_name', user_name);
    sessionStorage.setItem('user_roles', role);
    this.userSubject.next({ user_name, role: role.replace('ROLE_', '') });

    
  }

  // Déconnexion et suppression des informations utilisateur
  logout(): void {
    sessionStorage.removeItem('user_name');
    sessionStorage.removeItem('user_roles');
    sessionStorage.removeItem('user_token');
    sessionStorage.removeItem('user_id');
    sessionStorage.removeItem('user_username');
    this.userSubject.next(null); // Réinitialiser l'état de l'utilisateur
  }
}
